import React from "react";
import { View, TouchableOpacity } from "react-native-web";
import { WebView } from "react-native-web-webview";
import { TranslateText } from "./translate-text";

const QualtricsTask = ({ task, completeTask }) => {
  return (
    <View
      style={{
        height: "100%",
        backgroundColor: "#F3F4F6",
        padding: 4,
        width: "100%",
      }}
    >
      <View
        style={{
          height: "80%",
          backgroundColor: "#FFF",
          padding: 4,
          width: "100%",
          marginVertical: 4,
        }}
      >
        <WebView
          source={{ uri: task.qualtricsLink }}
          style={{ width: "100%", height: 720 }}
        />
      </View>
      {/* <TouchableOpacity
        style={{
          backgroundColor: "#FFF",
          padding: 4,
          width: "100%",
          marginVertical: 4,
          borderBottomLeftRadius: 12,
          borderBottomRightRadius: 12,
        }}
        onPress={completeTask}
      >
        <TranslateText
          style={{ textAlign: "center", color: "#33CF71", padding: 12 }}
        >
          DONE
        </TranslateText>
      </TouchableOpacity> */}
    </View>
  );
};

export default QualtricsTask;
